import ReactConfetti from "react-confetti";
import { useWindowSize } from "react-use";

import { Particles } from "./Sections/components/Particles";
import { NavigationTabs } from "./Sections/components/NavigationTabs";

import { Hero } from "./Sections/components/Hero";
import { Engagement } from "./Sections/Engagement";
import type { CommunityGrowthMetrics, EngagementMetrics } from "./types";

interface EoyRecapAppProps {
  metrics: {
    content_experience: EngagementMetrics;
    community_growth: CommunityGrowthMetrics;
  };
}

export const EoyRecapApp = ({ metrics }: EoyRecapAppProps) => {
  const { width, height } = useWindowSize();

  return (
    <main className="bg-[#0F0F35]">
      <ReactConfetti
        width={width}
        height={height}
        style={{
          zIndex: 999999,
        }}
        recycle={false}
        tweenDuration={6000}
        numberOfPieces={100}
        gravity={0.15}
        wind={0.05}
        colors={[
          "#a855f7",
          "#9333ea",
          "#7e22ce",
          "#6b21a8",
          "#ffffff",
          "#fbbf24",
          "#f59e0b",
        ]}
        initialVelocityY={-20}
        initialVelocityX={15}
      />
      <Particles />
      <NavigationTabs />
      <Hero />
      <Engagement data={metrics.content_experience} />
    </main>
  );
};
